import { Controller } from "stimulus";

const CHECK_VALUE = "delete";

export default class extends Controller {
  static values = { warningMessage: String };
  static targets = ["button", "warningMessage"];

  checkInputTextToEnableDeleteButton(e) {
    if (e.target.value.toLowerCase() === CHECK_VALUE) {
      this.warningMessageTarget.innerText = "";
      this.buttonTarget.disabled = false;
    } else {
      this.warningMessageTarget.innerText = this.warningMessageValue;
      this.buttonTarget.disabled = true;
    }
  }
}
